// TODO(joshuan): Move this to the DB and create an editor
/**
 * Listing of people who volunteer and contribute part-time to translate and
 * support Khan Academy.
 */

import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";
import BalanceText from "react-balance-text";

import Button from "@khanacademy/wonder-blocks-button";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {doNotTranslate} from "@khan/i18n";
import {mediaQueries} from "@khan/shared-styles";
import {cssUrl, staticUrl} from "@khan/urls";

import {
    moduleHorizontalPadding,
    moduleHorizontalPaddingSmall,
    moduleLayout,
} from "#modules-package/styles.ts";
// eslint-disable-next-line no-restricted-imports -- TODO: Replace this component with the equivalent one from Wonder Blocks.
import {deprecatedTypography} from "#shared-styles-package/deprecated-typography.ts";

// TODO(michaelpolyak): This multi-column sections structure is similarly
// implemented in `supporters.jsx`, refactor types and `makeSection` utility so
// that they reside in one place and used by both pages.
type ImageRow = {
    imageUrl: string;
    // An optional image specific aphrodite style.
    extraStyle?: any;
};

type Supporter =
    | {
          heading: string;
      }
    | {
          subheading: string;
      }
    | {
          name: string;
          link?: string;
      }
    | {
          caption: string;
      }
    | {
          blank: true;
      }
    | ImageRow;

type Section = {
    iconUrl?: string;
    title?: string;
    columns: Array<Array<Supporter>>;
};

const sm = "Stéphane Moutier";
const aa = "Alya Armali";
const cc = "Charlotte Cornet";
const hd = "Habiba Dyani";
const vd = "Victoire Dunker";
const as = "Assem Sarybekova";
const gk = "Gulmira Kairzhanova";
const name = "Marjorie";

const getSections = (): Record<string, Section> => ({
    translationSupporters: {
        iconUrl: "/images/volunteer-credits/translators.svg",
        title: t`Translation supporters`,
        columns: [
            [
                {heading: t`American Sign Language`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: t`National Technical Institute for the Deaf, Rochester Institute of Technology`,
                    link: "https://www.rit.edu/ntid/",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`National Science Foundation`,
                },

                {heading: t`Armenian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: t`Armenian Translators Team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360022981172-%D5%80%D5%A1%D5%B5%D5%A1%D5%AC%D5%A5%D5%A6%D5%B8%D6%82-%D5%A9%D5%AB%D5%B4-The-Armenian-Team",
                },
                {
                    name: doNotTranslate`Ayb Educational Foundation`,
                    link: "https://foundation.ayb.am/en/about",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`Renaissance Cultural and Intellectual Foundation`,
                    link: "https://rf.am/?lang=en",
                },
                {
                    name: doNotTranslate`European Union and World Vision Armenia ("EU4Youth - SAY YES Skills for Jobs" program)`,
                },
                {
                    name: doNotTranslate`Ayb Educational Foundation`,
                    link: "https://foundation.ayb.am/en/supporters",
                },

                {heading: t`Azerbaijani`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Leyla Gasimova`,
                },
                {
                    name: doNotTranslate`Ayaz Karimov`,
                },
                {
                    name: t`Khan Academy Azərbaycanca`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360040712732-Az%C9%99rbaycan-komandas%C4%B1-Azerbaijani-Team-",
                },

                {heading: t`Bangla`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Dilruba Chowdhury`},
                {
                    name: doNotTranslate`Agami`,
                    link: "https://www.agami.org/",
                },
                {
                    name: t`Bangla team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360035818672-%E0%A6%AC%E0%A6%BE%E0%A6%82%E0%A6%B2%E0%A6%BE-%E0%A6%A6%E0%A6%B2-The-Bangla-team",
                },
                {subheading: t`Stewards`},
                {name: doNotTranslate`Grameenphone Ltd.`},
                {
                    name: doNotTranslate`Ministry of ICT – Government of Bangladesh`,
                },
                {
                    name: doNotTranslate`Standard Chartered Bank, Bangladesh`,
                },

                {heading: t`Bulgarian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: t`Bulgarian translation team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360010442672-%D0%91%D1%8A%D0%BB%D0%B3%D0%B0%D1%80%D1%81%D0%BA%D0%B8%D1%8F%D1%82-%D0%B5%D0%BA%D0%B8%D0%BF-The-Bulgarian-Team",
                },
                {
                    name: doNotTranslate`Rozalina Laskova`,
                },
                {
                    name: doNotTranslate`Obrazovanie bez ranitsi (Education Without Backpacks)`,
                    link: "https://obr.education/en/",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`The America for Bulgaria Foundation`,
                },

                {heading: t`Burmese`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Khan Academy Myanmar Community`,
                },
                {
                    name: doNotTranslate`Khan Academy Burmese Translation`,
                    link: "http://www.khanacademyburmese.org ",
                },
                {
                    name: t`Burmese team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360020696512-%E1%80%99%E1%80%BC%E1%80%94-%E1%80%99%E1%80%AC%E1%80%A1%E1%80%9E%E1%80%84-%E1%80%B8-The-Burmese-team",
                },

                {heading: t`Chinese (Simplified)`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`eEasy Foundation`,
                    link: "https://eeasy.org/",
                },
                {
                    name: t`Chinese translation team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360012809592-%E7%AE%80%E4%BD%93%E4%B8%AD%E6%96%87%E6%96%87%E6%9C%AC%E7%BF%BB%E8%AF%91%E5%9B%A2%E9%98%9F-The-Simplified-Chinese-Translation-Team",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`Global Citizen Youth Leadership Academy`,
                },

                {heading: t`Czech`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Daniel Hollas, Markéta Matějíčková, Martina Rubešová, Petra Jirůtková, Alena Vlachová`,
                },
                {
                    name: doNotTranslate`Khanova skola z.s.`,
                    link: "https://khanovaskola.cz/o-skole",
                },
                {
                    name: t`Czech team`,
                    link: "https://support.khanacademy.org/hc/articles/360048926171-%C4%8Cesk%C3%BD-t%C3%BDm-The-Czech-Team",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`Bakalari Software`,
                    link: "https://www.bakalari.cz",
                },

                {heading: t`Danish`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Kenni Hyldahl`,
                },
                {
                    name: doNotTranslate`Orhan Klardashti`,
                },
                {
                    name: t`Danish team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360020642472-Det-danske-hold-The-Danish-Team",
                },
                {subheading: t`Stewards`},
                {name: doNotTranslate`Lundbeck Fonden`},
                {name: doNotTranslate`KMD`},

                {heading: t`Dutch`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Erik Mooij, Stichting Khan Academy Nederland`,
                },
                {
                    name: t`Khan Academy Netherlands project`,
                    link: "https://www.khanacademy.nl/",
                },
                {
                    name: t`Dutch/Flemish team`,
                    link: "https://support.khanacademy.org/hc/en-us/articles/360059927231-Het-Nederlandse-Vlaamse-team-The-Dutch-Flemish-Team",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`Up Foundation`,
                    link: "https://fondation-up.org/",
                },
                {
                    name: doNotTranslate`Degroof Petercam Foundation`,
                    link: "https://www.degroofpetercam.com/fr/impact-societal/degroof-petercam-foundation",
                },

                {heading: t`French`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: t`France: ${sm}`,
                },
                {
                    name: t`Belgium: ${aa}, ${cc}, ${hd}, ${vd}`,
                },
                {
                    name: doNotTranslate`Bibliothèques Sans Frontières (Libraries without Borders)`,
                    link: "https://www.bibliosansfrontieres.org",
                },
                {
                    name: t`French team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360020640812-L-%C3%A9quipe-fran%C3%A7aise-The-French-Team",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`Orange Foundation`,
                    link: "https://www.fondationorange.com",
                },
                {
                    name: doNotTranslate`Up Foundation`,
                    link: "https://fondation-up.org/",
                },
                {
                    name: doNotTranslate`Degroof Petercam Foundation`,
                    link: "https://www.degroofpetercam.com/fr/impact-societal/degroof-petercam-foundation",
                },
                {
                    name: doNotTranslate`Fédération Wallonie-Bruxelles`,
                    link: "http://www.federation-wallonie-bruxelles.be/",
                },
                {
                    name: doNotTranslate`Innoviris Brussels`,
                    link: "https://innoviris.brussels/fr",
                },
                {
                    name: doNotTranslate`Belgian Family Foundation`,
                },
                {
                    name: t`Private donors`,
                },

                {heading: t`Fulfulde Mbororoore`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Chris Jackson, Carolin Jackson, Dayyibu Abdullaahi`,
                },

                {heading: t`Georgian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Roussoudane Djakeli`},
                {name: doNotTranslate`Nina Nutsubidze`},
                {name: doNotTranslate`Razmik Badalyan`},
                {
                    name: doNotTranslate`George Jibladze`,
                },
                {
                    name: doNotTranslate`EduCare Georgia`,
                    link: "http://www.educaregeorgia.org/",
                },
                {
                    name: doNotTranslate`Georgian Translators`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360009070571-%E1%83%A5%E1%83%90%E1%83%A0%E1%83%97%E1%83%A3%E1%83%9A%E1%83%98-%E1%83%92%E1%83%A3%E1%83%9C%E1%83%93%E1%83%98-The-Georgian-team",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`The Educare Georgia Donors Club`,
                    link: "http://www.educaregeorgia.org/supporters/partners/",
                },
            ],
            [
                {heading: t`German`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Lothar Klinkhammer`,
                },
                {
                    name: doNotTranslate`KA Deutsch e.V.`,
                    link: "https://www.kadeutsch.org",
                },
                {subheading: t`Stewards`},
                {name: doNotTranslate`IAETH`},
                {name: doNotTranslate`Google`},
                {name: doNotTranslate`VR Bank Main-Kinzig-Büdingen`},
                {name: doNotTranslate`VR Bank Schlüchtern-Birstein`},
                {name: doNotTranslate`Rotary e.V. Bad Orb`},

                {heading: t`Greek`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Chris Vaios`},
                {
                    name: doNotTranslate` Mathaino, Inc.`,
                    link: "https://mathaino.org/?lang=el",
                },
                {
                    name: t`Greek team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360021573432-%CE%97-%CE%95%CE%BB%CE%BB%CE%B7%CE%BD%CE%B9%CE%BA%CE%AE-%CE%9F%CE%BC%CE%AC%CE%B4%CE%B1-The-Greek-Team",
                },

                {heading: t`Gujarati`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Nima Solanki`,
                },
                {
                    name: doNotTranslate`Rajeev Topiwala`,
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`NJ Group`,
                },

                {heading: t`Hindi`},
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`The Central Square Foundation`,
                },

                {heading: t`Hungarian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Eszter Lovas`},
                {
                    name: doNotTranslate`Akadémia Határok Nélkül Alapítvány`,
                    link: "http://akademiahataroknelkul.hu",
                },
                {
                    name: t`Hungarian team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360016289291-A-magyar-csapat-The-Hungarian-Team",
                },

                {heading: t`Italian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Letizia Iannucci`},

                {heading: t`Japanese`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Nobuko Hamaguchi`},
                {name: doNotTranslate`Hitoshi Yamauchi`},
                {
                    name: t`Japanese team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360016049411-%E6%97%A5%E6%9C%AC%E8%AA%9E%E5%8C%96%E3%83%81%E3%83%BC%E3%83%A0-The-Japanese-Team",
                },

                {heading: t`Kannada`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Department of State Educational Research and Training`,
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`The Government of Karnataka`,
                },

                {heading: t`Kazakh (Qazaq)`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Aisulu Maksotova`,
                },
                {
                    name: t`Project managers: ${as}, ${gk}`,
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`Exclusive Qurylys`,
                },

                {heading: t`Khmer`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Ted Kaburaki`},

                {heading: t`Korean`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: t`Korean team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360020896531-%ED%95%9C%EA%B5%AD%ED%8C%80-The-Korean-Team",
                },
                {
                    name: doNotTranslate`NAVER Connect Foundation`,
                    link: "https://connect.or.kr/",
                },

                {heading: t`Kyrgyz`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Gulzire Minbaeva`,
                },

                {heading: t`Latvian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Pāvils Jurjāns`,
                },
                {
                    name: doNotTranslate`Latvian team`,
                    link: "https://support.khanacademy.org/hc/en-us/articles/4407784419341-Latvie%C5%A1u-valodas-komanda-The-Latvian-team",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`Plus Educere Foundation`,
                    link: "https://pluseducere.org/",
                },

                {heading: t`Lithuanian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Adele Gurklyte`,
                },
                {
                    name: doNotTranslate`Fondas 17`,
                    link: "https://www.fondas17.lt/",
                },
                {
                    name: doNotTranslate`Lithuanian team`,
                    link: "https://support.khanacademy.org/hc/en-us/articles/4422809940621-Lietuvi%C5%B3-komanda-The-Lithuanian-Team",
                },

                {heading: t`Mongolian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Burmaa Baasansuren, One Foundation `,
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`The Ministry of Education and Science of Mongolia`,
                },

                {heading: t`Norwegian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Jens Tore Fremmegaard`},

                {heading: t`Pashto`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Ihsan Shagiwal, Spojmie Nasiri`,
                },
                {
                    name: doNotTranslate`We Have Hope Foundation`,
                    link: "https://www.wehavehope.org/",
                },
                {
                    name: t`Pashto team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360035494331-The-Pashto-team-%D8%AF-%D9%BE%DA%9A%D8%AA%D9%88-%D9%BC%DB%8C%D9%85-",
                },

                {heading: t`Polish`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Lech Mankiewicz`,
                },
                {
                    name: doNotTranslate`Edukacja dla Przyszłości`,
                    link: "http://www.edukacjaprzyszlosci.pl/",
                },
                {subheading: t`Stewards`},
                {name: doNotTranslate`Fundacja AVIVA`},
                {name: doNotTranslate`Instytute of Philosophy UW`},
                {
                    name: doNotTranslate`Institute of Organic Chemistry PAS`,
                },
                {
                    name: doNotTranslate`Center for Theoretical Physics PAS`,
                },
                {name: doNotTranslate`Fundacja Banku PKO BP`},
                {name: doNotTranslate`Fundacja Orange`},
                {name: doNotTranslate`Fundacja HASCO-LEK`},
            ],
            [
                {heading: t`Portuguese, Brazilian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Brazilian Portuguese volunteer translators`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360006952791-O-time-Brasil-The-Brazilian-Portuguese-team",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`Fundação Lemann`,
                },

                {heading: t`Portuguese, European`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Daniel Freitas`},
                {name: doNotTranslate`Ana Lourenço`},
                {
                    name: t`European Portuguese team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360031879052-A-equipa-em-Portugal-The-European-Portuguese-",
                },

                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`Fundação Altice Portugal`,
                    link: "https://fundacao.telecom.pt",
                },

                {heading: t`Romanian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Anca Bărbulescu`,
                },
                {
                    name: doNotTranslate`Invenovi (Education through Innovation)`,
                    link: "http://invenovi.org/",
                },
                {
                    name: t`Romanian team`,
                    link: "https://support.khanacademy.org/hc/en-us/articles/360058649011-Echipa-Rom%C3%A2niei-The-Romanian-Team",
                },

                {heading: t`Russian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Christine Lumen`},
                {
                    name: doNotTranslate`EducationX MTU`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360020641352-%D0%A0%D1%83%D1%81%D1%81%D0%BA%D0%BE%D1%8F%D0%B7%D1%8B%D1%87%D0%BD%D0%B0%D1%8F-%D0%BA%D0%BE%D0%BC%D0%B0%D0%BD%D0%B4%D0%B0-The-Russian-Team",
                },

                {heading: t`Serbian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Igor Popov`},

                {heading: t`Spanish`},
                {subheading: t`Stewards`},
                {name: doNotTranslate`Fundación Carlos Slim`},
                {name: doNotTranslate`Carlos Rodriguez-Pastor`},

                {heading: t`Swedish`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Olof Paulson`},

                {heading: t`Tamil`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Sivagami Ramiah`},
                {name: doNotTranslate`Jayakumar Krishnadass`},
                {name: doNotTranslate`Chockkalingam Karuppaiah`},
                {name: doNotTranslate`Tamil Virtual Academy`},
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`The Vetrivel Foundation`,
                    link: "http://www.vetrivelfoundation.org",
                },

                {heading: t`Thai`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Umnouy (Tee) Ponsukcharoen, Khan Academy Thailand`,
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`The Sakdibhornssup Foundation`,
                },

                {heading: t`Turkish`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Bilimsel ve Teknik Yayınları Çeviri Vakfı (Foundation for Translation of Scientific and Technical Publications)`,
                },
                {name: doNotTranslate`STFA`},
                {name: doNotTranslate`Alp Köksal`},
                {
                    name: t`Turkish team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360037662392-T%C3%BCrk-tak%C4%B1m%C4%B1-The-Turkish-Team",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`Bilimsel ve Teknik Yayınları Çeviri Vakfı (Foundation for Translation of Scientific and Technical Publications)`,
                    link: "http://www.herseyiogrenebilirsin.org",
                },

                {heading: t`Ukrainian`},
                {subheading: t`Advocate(s)/Non-profit`},
                {name: doNotTranslate`Bohdan Kornienko`},

                {heading: t`Urdu`},
                {subheading: t`Stewards`},
                {
                    name: t`Ministry of Federal Education and Professional Training, Pakistan`,
                },

                {heading: t`Uzbek`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`Bilim Onlayn`,
                    link: "https://xanakademiyasi.uz/",
                },
                {
                    name: t`Uzbek team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360032219511-O%CA%BBzbekiston-jamoasi-The-Uzbek-Team",
                },

                {heading: t`Vietnamese`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: t`Vietnamese team`,
                    link: "https://support.khanacademy.org/hc/en-us/articles/360059513772-Nh%C3%B3m-Vi%E1%BB%87t-Nam-The-Vietnamese-Team",
                },
                {subheading: t`Stewards`},
                {
                    name: doNotTranslate`The Vietnam Foundation`,
                    link: "http://vnfoundation.org/",
                },

                {heading: t`Xhosa / Zulu`},
                {subheading: t`Advocate(s)/Non-profit`},
                {
                    name: doNotTranslate`JJ Miranda / Pratik Pokharel / Adrian Cox - ClickMaths NPO`,
                    link: "https://www.clickmaths.org/",
                },
                {
                    name: t`Xhosa and Zulu team`,
                    link: "https://khanacademy.zendesk.com/hc/en-us/articles/360024203131-isiXhosa-isiZulu-Xhosa-and-Zulu-team",
                },
                {subheading: t`Stewards`},
                {name: doNotTranslate`Dave Marsh`},
                {name: doNotTranslate`Miklos Solomon`},
                {name: doNotTranslate`Now Media`},
                {name: doNotTranslate`BCX`},

                {
                    imageUrl: "/images/volunteer-credits/balloons.svg",
                    // We compile this style inline since the `styles` below
                    // are not yet instantiated.
                    extraStyle: StyleSheet.create({
                        // eslint-disable-next-line react-native/no-unused-styles
                        balloonsImage: {
                            paddingTop: 112,

                            [mediaQueries.mdOrSmaller]: {
                                paddingTop: 56,
                            },
                        },
                    }).balloonsImage,
                },
            ],
        ],
    },

    currentVolunteers: {
        iconUrl: "/images/volunteer-credits/volunteers.svg",
        title: t`Volunteers`,
        columns: [
            [
                {subheading: t`Current Volunteers`},

                {name: doNotTranslate`Evan Lewis`},
                {
                    caption: t`Support Volunteer, Discussion community Guardian, Special Projects (2017 - present)`,
                },

                {blank: true},
                {name: doNotTranslate`Jett Burns`},
                {
                    caption: t`Support Volunteer, Special Projects (2017 - present)`,
                },

                {blank: true},
                {name: doNotTranslate`Katrina (Kat.RoseAngel)`},
                {caption: t`Support Volunteer (2017 - present)`},
            ],
            [
                {blank: true},
                {name: doNotTranslate`Josh Kline`},
                {
                    caption: t`Support Volunteer, Discussion community Guardian, Special Projects (2015 - present)`,
                },

                {blank: true},
                {name: doNotTranslate`Lisa Krueger`},
                {caption: t`Support Volunteer (2016 - present)`},

                {blank: true},
                {name: doNotTranslate`Andrew M`},
                {
                    caption: t`Discussion community Guardian (2012 - present)`,
                },
            ],
            [
                {blank: true},
                {name: doNotTranslate`Gilbert Saller`},
                {
                    caption: t`Support Volunteer, Discussion community Guardian (2016 - present)`,
                },

                {blank: true},
                {name: doNotTranslate`Evan Silverman “Eytukan”`},
                {
                    caption: t`Discussion community Guardian (2017 - present)`,
                },

                {blank: true},
                {name: doNotTranslate`Davin V Jones “elentir”`},
                {
                    caption: t`Discussion community Guardian (2015 - present)`,
                },
            ],
        ],
    },

    pastVolunteers: {
        columns: [
            [
                {subheading: t`Past Volunteers`},
                {name: doNotTranslate`Simran Anand`},
                {caption: t`Special Projects (2015)`},

                {blank: true},
                {name: doNotTranslate`Maneesh Arora`},
                {caption: t`Special Projects (2010)`},

                {blank: true},
                {name: doNotTranslate`Brynden Bielefeld`},
                {caption: t`Special Projects (2015)`},

                {blank: true},
                {name: doNotTranslate`Greg Boyle`},
                {
                    caption: t`Discussion community Guardian (2012 - 2014)`,
                },

                {blank: true},
                {name: doNotTranslate`Dean Brettle`},
                {caption: t`Special Projects (2010 - 2011)`},

                {blank: true},
                {name: doNotTranslate`Matthew Daly`},
                {
                    caption: t`Discussion community Guardian (2012 - 2017)`,
                },

                {blank: true},
                {name: doNotTranslate`Barry Desborough`},
                {
                    caption: t`Discussion community Guardian (2013 - 2014)`,
                },

                {blank: true},
                {name: doNotTranslate`Ethan Dlugie`},
                {
                    caption: t`Discussion community Guardian (2013 - 2014)`,
                },

                {blank: true},
                {name: doNotTranslate`Joshua Gammage`},
                {caption: t`Special Projects (2015 - 2016)`},

                {blank: true},
                {name: doNotTranslate`Alicia Gumm`},
                {caption: t`Support Volunteer (2014)`},
            ],
            [
                {blank: true},
                {name: doNotTranslate`Isaac Fingerson`},
                {
                    caption: t`Special Projects, Discussion community Guardian (2013 - 2014)`,
                },

                {blank: true},
                {name: doNotTranslate`Dhaval Furia`},
                {caption: t`Support Volunteer (2015)`},

                {blank: true},
                {name: doNotTranslate`Wesley Johnson`},
                {
                    caption: t`Discussion community Guardian (2012 - 2014)`,
                },

                {blank: true},
                {name: doNotTranslate`Vishal Kapur`},
                {caption: t`Special Projects (2010)`},

                {blank: true},
                {name: doNotTranslate`Keith (Just Keith)`},
                {caption: t`Discussion community Guardian (2014)`},

                {blank: true},
                {name: doNotTranslate`John Linderman`},
                {caption: t`Support Volunteer (2014 - 2016)`},

                {blank: true},
                {name: doNotTranslate`Matthias (MatthiasSaihttam)`},
                {caption: t`Special Projects (2016)`},

                {blank: true},
                {name: doNotTranslate`Cindy Mayo “trek”`},
                {
                    caption: t`Discussion community Guardian, Support Volunteer (2016 - 2017)`,
                },

                {blank: true},
                {name: doNotTranslate`Robby Olivam`},
                {
                    caption: t`Discussion community Guardian (2014 - 2016)`,
                },

                {blank: true},
                {name: doNotTranslate`Julianne Russell`},
                {caption: t`Support Volunteer (2016 - 2018)`},
            ],
            [
                {blank: true},
                {name: doNotTranslate`Alexander Øvestad`},
                {caption: t`Discussion community Guardian (2012)`},

                {blank: true},
                {name: doNotTranslate`Purav Patel`},
                {
                    caption: t`Discussion community Guardian (2012 - 2014)`,
                },

                {blank: true},
                {name: doNotTranslate`Omar Rizwan`},
                {caption: t`Special Projects (2012)`},

                {blank: true},
                {name: doNotTranslate`Christi Rockwell`},
                {
                    caption: t`Support Volunteer, Discussion community Guardian (2014 - 2016)`,
                },

                {blank: true},
                {name: doNotTranslate`Jahanzeb Sherwani`},
                {caption: t`Special Projects (2010)`},

                {blank: true},
                {name: doNotTranslate`John Sutton`},
                {caption: t`Discussion community Guardian (2017)`},

                {blank: true},
                {name: doNotTranslate`Chuck Towle`},
                {
                    caption: t`Discussion community Guardian (2013 - 2014)`,
                },

                {blank: true},
                {name: doNotTranslate`Aaron Wallach`},
                {caption: t`Support Volunteer (2014 - 2017)`},

                {blank: true},
                {name: doNotTranslate`Inger Hohler`},
                {
                    caption: t`Support Volunteer, Discussion community Guardian, Special Projects (2014 - 2017)`,
                },

                {blank: true},
                {name: doNotTranslate`Megan Grochowiak`},
                {caption: t`Support Volunteer (2016 - 2018)`},
            ],
        ],
    },
});

const TESTIMONIALS = () => ({
    marjorie: {
        quote: t`Volunteering for Khan Academy makes me feel like, in my small way, I’m helping to change the world.`,
        source: t`${name}, 36`,
    },
});

function makeSection(section: Section) {
    const columns = section.columns.map(
        (column: Array<Supporter>, colIndex) => {
            const rows = column.map((row: Supporter, rowIndex) => {
                // A supporter row can display an image.
                // @ts-expect-error - TS2339 - Property 'imageUrl' does not exist on type 'Supporter'.
                if (row.imageUrl) {
                    const imageRow = row as ImageRow;
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Supporter'.
                    const altText = row.name || t`Volunteer Credits`;

                    return (
                        <li key={rowIndex}>
                            <img
                                className={css(
                                    styles.supportersImage,
                                    imageRow.extraStyle,
                                )}
                                src={staticUrl(imageRow.imageUrl)}
                                alt={altText}
                            />
                        </li>
                    );
                }

                const text: any =
                    // @ts-expect-error - TS2339 - Property 'heading' does not exist on type 'Supporter'.
                    row.heading ||
                    // @ts-expect-error - TS2339 - Property 'subheading' does not exist on type 'Supporter'.
                    row.subheading ||
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Supporter'.
                    row.name ||
                    // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'Supporter'.
                    row.caption ||
                    null;

                // @ts-expect-error - TS2339 - Property 'link' does not exist on type 'Supporter'.
                const textOrLink = row.link ? (
                    <a
                        href={(row as TSFixMe).link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {text}
                    </a>
                ) : (
                    text
                );

                // It can also display a heading, sub-heading, name, caption
                // (in decreasing visual size) or display a blank row to align
                // across columns.
                return (
                    <li
                        className={css(
                            // Heading row styles
                            // @ts-expect-error - TS2339 - Property 'heading' does not exist on type 'Supporter'.
                            row.heading && styles.supportersHeading,
                            // @ts-expect-error - TS2339 - Property 'heading' does not exist on type 'Supporter'.
                            row.heading &&
                                rowIndex > 0 &&
                                styles.supportersHeadingGap,
                            // @ts-expect-error - TS2339 - Property 'heading' does not exist on type 'Supporter'.
                            row.heading &&
                                colIndex === 0 &&
                                rowIndex === 0 &&
                                styles.supportersFirstColRow,
                            // Sub-heading row styles
                            // @ts-expect-error - TS2339 - Property 'subheading' does not exist on type 'Supporter'.
                            row.subheading && styles.supportersSubheading,
                            // @ts-expect-error - TS2339 - Property 'subheading' does not exist on type 'Supporter'.
                            row.subheading &&
                                rowIndex > 0 &&
                                styles.supportersHeadingGap,
                            // @ts-expect-error - TS2339 - Property 'subheading' does not exist on type 'Supporter'.
                            row.subheading &&
                                colIndex === 0 &&
                                rowIndex === 0 &&
                                styles.supportersFirstColRow,
                            // Name row styles
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Supporter'.
                            row.name && styles.supportersName,
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Supporter'.
                            row.name &&
                                colIndex === 0 &&
                                rowIndex === 0 &&
                                styles.supportersFirstColRow,
                            // Caption row styles
                            // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'Supporter'.
                            row.caption && styles.supportersCaption,
                            // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'Supporter'.
                            row.caption &&
                                colIndex === 0 &&
                                rowIndex === 0 &&
                                styles.supportersFirstColRow,
                            // Blank row styles
                            // @ts-expect-error - TS2339 - Property 'blank' does not exist on type 'Supporter'.
                            row.blank && styles.supportersBlankRow,
                        )}
                        key={rowIndex}
                    >
                        {textOrLink}
                    </li>
                );
            });

            return (
                <ul className={css(styles.supportersList)} key={colIndex}>
                    {rows}
                </ul>
            );
        },
    );

    const {iconUrl} = section;

    return (
        <div className={css(styles.sectionContainer)}>
            {(iconUrl || section.title) && (
                <div className={css(styles.sectionHeader)}>
                    {iconUrl && (
                        <img
                            className={css(styles.sectionIcon)}
                            src={staticUrl(iconUrl)}
                            alt={section.title}
                        />
                    )}

                    {section.title && (
                        <h3 className={css(styles.sectionTitle)}>
                            {section.title}
                        </h3>
                    )}
                </div>
            )}

            <div className={css(styles.sectionColumns)}>{columns}</div>
        </div>
    );
}

// TODO(michaelpolyak): Refactor as shared component to be used by `impact.jsx`
// and this page.
const Testimonial = (props: {quote: string; source: string}) => (
    <div className={css(styles.testimonialContainer)}>
        <div className={css(styles.testimonialContent)}>
            <h4 className={css(styles.testimonialQuote)}>{props.quote}</h4>
            <div className={css(styles.testimonialSource)}>{props.source}</div>
        </div>
    </div>
);

// TODO(michaelpolyak): Refactor as shared component to be used by `impact.jsx`,
// `supporters.jsx` and this page.
const HorizontalDivider = () => (
    <div className={css(styles.dividerContainer)}>
        <hr className={css(styles.dividerHorizontal)} />
    </div>
);

// TODO(michaelpolyak): Similar callout is used in `impact.jsx`, this should be
// refactored as a shared component.
const VolunteerCallout = () => (
    <div className={css(styles.volunteerContainer)}>
        <h3 className={css(styles.volunteerHeader)}>
            {t`Want to help Khan Academy support even more learners?`}
        </h3>

        <Button href="/contribute" style={styles.volunteerButton}>
            {t`Volunteer`}
        </Button>
    </div>
);

const VolunteerCreditsPage = (): React.ReactElement<
    React.ComponentProps<"div">
> => {
    const SECTIONS = getSections();
    return (
        <div>
            <div className={css(styles.thankyouContainer)}>
                <h2 className={css(styles.thankyouHeading)}>
                    <BalanceText>
                        {t`Khan Academy would like to thank all who’ve dedicated their time, energy, and expertise to our mission.`}
                    </BalanceText>
                </h2>
            </div>
            {makeSection(SECTIONS.translationSupporters)}
            <Testimonial {...TESTIMONIALS().marjorie} />
            {makeSection(SECTIONS.currentVolunteers)}
            <HorizontalDivider />
            {makeSection(SECTIONS.pastVolunteers)}
            <img
                className={css(styles.peopleImage)}
                src={staticUrl("/images/volunteer-credits/people.svg")}
                alt={t`People holding hands`}
            />
            <VolunteerCallout />
        </div>
    );
};

const styles = StyleSheet.create({
    thankyouContainer: {
        paddingTop: 80,
        paddingBottom: 80,
        backgroundColor: "#708b89",
        backgroundImage: cssUrl("/images/volunteer-credits/bg-hero.png"),
        backgroundSize: "cover",
        backgroundPosition: "50% 10%",
        color: color.white,
    },

    thankyouHeading: {
        ...deprecatedTypography.conceptHeadingDesktop,
        maxWidth: 600,
        margin: "auto",
        paddingLeft: moduleHorizontalPadding,
        paddingRight: moduleHorizontalPadding,
        lineHeight: 1.34,
        color: color.white,
        textAlign: "center",

        [mediaQueries.mdOrSmaller]: {
            ...deprecatedTypography.conceptHeadingMobile,
            paddingLeft: moduleHorizontalPaddingSmall,
            paddingRight: moduleHorizontalPaddingSmall,
            lineHeight: 1.34,
        },
    },

    sectionContainer: {
        ...moduleLayout.defaultAlignment,
        ...moduleLayout.defaultSpacing,
        paddingTop: 0,
        paddingBottom: 0,
        fontWeight: "normal",
        color: "#191b21",

        [mediaQueries.mdOrSmaller]: {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },

    sectionHeader: {
        ...moduleLayout.defaultAlignment,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 44,
        marginBottom: 44,

        [mediaQueries.mdOrSmaller]: {
            marginTop: 34,
            marginBottom: 34,
        },
    },

    sectionIcon: {
        marginRight: 26,
    },

    sectionTitle: {
        ...deprecatedTypography.conceptHeadingDesktop,
        marginBottom: 0,
        color: color.offBlack,

        [mediaQueries.mdOrSmaller]: {
            ...deprecatedTypography.conceptHeadingMobile,
        },
    },

    sectionColumns: {
        display: "flex",
        marginTop: 44,
        marginBottom: 44,

        [mediaQueries.mdOrSmaller]: {
            flexDirection: "column",
            marginTop: 34,
            marginBottom: 34,
        },
    },

    supportersList: {
        ...deprecatedTypography.bodyLarge,
        flex: 1,
        lineHeight: 1.75,

        [mediaQueries.lgOrLarger]: {
            ":not(:last-child)": {
                marginRight: 16,
            },
        },

        [mediaQueries.mdOrSmaller]: {
            ...deprecatedTypography.bodySmall,
            lineHeight: 1.75,
        },
    },

    supportersHeading: {
        ...deprecatedTypography.conceptHeadingDesktop,

        [mediaQueries.mdOrSmaller]: {
            ...deprecatedTypography.conceptHeadingMobile,
            marginTop: 37,
        },
    },

    supportersHeadingGap: {
        marginTop: 37,
    },

    supportersSubheading: {
        fontWeight: "bold",
    },

    supportersName: {
        lineHeight: 1.25,

        ":not(:first-child)": {
            marginTop: 15,
        },

        [mediaQueries.mdOrSmaller]: {
            marginTop: 15,
        },
    },

    supportersCaption: {
        ...deprecatedTypography.bodyXsmall,

        ":not(:first-child)": {
            marginTop: 5,
        },
    },

    supportersFirstColRow: {
        marginTop: 0,

        [mediaQueries.mdOrSmaller]: {
            marginTop: 0,
        },
    },

    supportersBlankRow: {
        display: "inline-block",

        [mediaQueries.mdOrSmaller]: {
            display: "none",
        },
    },

    supportersImage: {
        display: "block",
        margin: "auto",
    },

    dividerContainer: {
        ...moduleLayout.defaultAlignment,
    },

    dividerHorizontal: {
        borderColor: color.offBlack16,
        borderStyle: "solid",
        borderWidth: "0 0 1px",
        boxShadow: "none",
        height: 0,
        margin: 0,
    },

    testimonialContainer: {
        backgroundColor: "#02a894",
    },

    testimonialContent: {
        ...moduleLayout.defaultAlignment,
        ...moduleLayout.defaultSpacing,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        paddingTop: 74,
        paddingBottom: 74,
        textAlign: "center",

        [mediaQueries.mdOrSmaller]: {
            paddingTop: 37,
            paddingBottom: 37,
        },
    },

    testimonialQuote: {
        ...deprecatedTypography.conceptHeadingDesktop,
        fontWeight: "normal",
        width: 590,
        color: color.white,

        [mediaQueries.mdOrSmaller]: {
            ...deprecatedTypography.conceptHeadingMobile,
            width: "inherit",
            fontWeight: "normal",
        },
    },

    testimonialSource: {
        ...deprecatedTypography.bodySmall,
        color: color.white,
        textTransform: "uppercase",

        [mediaQueries.mdOrSmaller]: {
            ...deprecatedTypography.bodyXsmall,
        },
    },

    peopleImage: {
        position: "relative",
        // There is a bit of an empty space at the bottom of the image that we
        // want to close.
        bottom: -6,
    },

    volunteerContainer: {
        height: 425,
        backgroundColor: "#085566",
        backgroundImage: cssUrl("/images/volunteer-credits/bg-cta.svg"),
        textAlign: "center",
    },

    volunteerHeader: {
        ...deprecatedTypography.subheadingDesktop,
        maxWidth: 450,
        margin: "0 auto",
        paddingTop: 145,
        paddingBottom: 25,
        paddingLeft: moduleHorizontalPadding,
        paddingRight: moduleHorizontalPadding,
        color: color.white,

        [mediaQueries.mdOrSmaller]: {
            ...deprecatedTypography.subheadingMobile,
            paddingLeft: moduleHorizontalPaddingSmall,
            paddingRight: moduleHorizontalPaddingSmall,
        },
    },

    volunteerButton: {
        minWidth: 222,
    },
});

export default VolunteerCreditsPage;
